var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"md-display-1"},[_vm._v("Fotos")]),_c('div',{staticClass:"row"},_vm._l((_vm.fotos),function(foto,i){return _c('div',{key:i,staticClass:"col-6 mt-4"},[_c('img',{attrs:{"src":foto,"alt":"Foto"}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }